import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"

export type TableLoadingBarProps = ComponentProps<"div"> & {
  isLoading: boolean
}

/**
 * Thin progress bar at the top of the table content area.
 * Shows during background refetches (sort/filter changes) without
 * replacing the table content.
 */
function TableLoadingBar(props: TableLoadingBarProps) {
  const { isLoading, className, ...divProps } = props
  if (!isLoading) return null
  return (
    <div className={cn("ui-table-loading-bar", className)} {...divProps}>
      <div className="ui-table-loading-bar-indicator" />
    </div>
  )
}

export default TableLoadingBar
